exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "/* .greeting{\n  padding-left: 0;\n  background-color: black;\n} */", ""]);

